import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../../../shared/error-boundary';
import PrimaryImageContext, { reducer } from './primary-image-components/context';
import Prompt from './primary-image-components/prompt';
import Viewer from './primary-image-components/viewer';
import Modal from '../../../shared/primary-image-modal';

export default function PrimaryImageControl(props) {
  const initialState = {
    ...props,
    showModal: false,
  };
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const modalProps = {
    ...state,
    onAssigned: url => dispatch({ type: 'setUrl', payload: url }),
    onClose: () => dispatch({ type: 'hideModal' }),
  };
  return (
    <ErrorBoundary>
      <PrimaryImageContext.Provider value={{ state, dispatch }}>
        <aside className="sidebar-item">
          <section className="form-group no-top-margin">
            {state.mediaUrl ? <Viewer /> : <Prompt />}
          </section>
        </aside>
        <Modal {...modalProps} />
      </PrimaryImageContext.Provider>
    </ErrorBoundary>
  );
}

/* eslint-disable react/no-unused-prop-types */
PrimaryImageControl.propTypes = {
  mediaUrl: PropTypes.string,
  wireId: PropTypes.number.isRequired,
};
/* eslint-enable react/no-unused-prop-types */

PrimaryImageControl.defaultProps = {
  mediaUrl: null,
};
